import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _extends from '@babel/runtime/helpers/extends';
import { Row, Col, Box, Flex, Label, RadioGroup, HStack, Radio, Text, Feedback, Checkbox, Link, useBreakpoint, Button } from '@hausgold/designsystem';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import WizardHeading from '../../WizardHeading.js';
import { ApiContext, WizardContext } from '../../../utils/contexts.js';
import sendTracking from '../../../utils/tracking.js';
import '../../../utils/yupPhone.js';
import { Parser } from 'html-to-react';
import { map } from 'lodash-es';
import PropTypes from 'prop-types';
import { useContext, useState, Fragment } from 'react';
import * as Yup from 'yup';
import formwizardApi from '../../../services/api/formwizardApi.js';
import { getOptinType, getMandatoryFieldOptions, getContactDescriptionText, getOptinContentText, getAuthenticityToken, getVersion, getAdditionalContentText } from '../../../services/models/dialog.js';
import FluidMaxContainer from '../../FluidMaxContainer.js';
import Input from '../../Input.js';
import TrustBox from '../../TrustBox.js';
import { jsx } from '@emotion/react';
var htmlToReactParser = new Parser();

/**
 * Get `html-to-react` processing instructions
 * @param type {'default'|'additionalContent'}
 * @return {[{shouldProcessNode: (function(*): boolean), processNode: (function(*): *)}]}
 */
var getHtmlToReactParserProcessingInstructions = function getHtmlToReactParserProcessingInstructions() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  return [{
    // This processing instruction correctly processes various tags, but removes the `<p />` tag
    // outside.
    //
    // We have to render links as `<Link />`, for example.
    shouldProcessNode: function shouldProcessNode(node) {
      return node.name === 'p';
    },
    processNode: function processNode(node) {
      return map(node.children, function (child, index) {
        if (child.type === 'comment') {
          return null;
        }
        if (child.name === 'a') {
          return jsx(Link, _extends({}, child.attribs, {
            fontSize: "inherit",
            key: index,
            colorScheme: type !== 'additionalContent' ? 'gray' : 'blue',
            textDecoration: type !== 'additionalContent' && 'underline'
          }), child.children.map(function (subChild) {
            return subChild.data;
          }));
        }
        if (child.name === 'br') {
          return jsx("br", {
            key: index
          });
        }
        if (child.name === 'strong') {
          return jsx("strong", {
            key: index
          }, child.children.map(function (subChild) {
            return subChild.data;
          }));
        }
        return child.data;
      });
    }
  }];
};
var SubmitButton = function SubmitButton(_ref) {
  var isLoading = _ref.isLoading;
  var isBiggerThanSM = useBreakpoint('sm', '>');
  return jsx(Button, {
    id: "button--userdata-submit",
    type: "submit",
    width: "100%",
    isLoading: isLoading
  }, isBiggerThanSM ? 'Meine Immobilienbewertung anfordern' : 'Meine Bewertung anfordern');
};
SubmitButton.propTypes = {
  isLoading: PropTypes.bool
};
SubmitButton.defaultProps = {
  isLoading: false
};
/**
 * Build validation schema
 * @param mandatoryFields
 */
var buildValidationSchema = function buildValidationSchema(mandatoryFields) {
  return Yup.object().shape({
    gender: mandatoryFields.gender ? Yup.string().required('Bitte wählen Sie eine Anrede aus.') : Yup.string(),
    firstName: mandatoryFields.firstName ? Yup.string().trim().required('Bitte geben Sie Ihren Vornamen ein.') : Yup.string(),
    lastName: mandatoryFields.lastName ? Yup.string().trim().required('Bitte geben Sie Ihren Nachnamen ein.') : Yup.string(),
    email: Yup.string().email('Geben Sie eine gültige E-Mail-Adresse für die kostenlose Immobilienbewertung an.').required('Geben Sie eine gültige E-Mail-Adresse für die kostenlose Immobilienbewertung an.'),
    phone: Yup.string().phone('DE', false, 'Geben Sie eine gültige Telefonnummer für die kostenlose Immobilienbewertung an.').trim().required('Geben Sie eine gültige Telefonnummer für die kostenlose Immobilienbewertung an.'),
    optIn: mandatoryFields.optIn ? Yup.bool().oneOf([true], 'Bitte akzeptieren Sie die Datenschutzbestimmungen.') : Yup.mixed()
  });
};
var UserDataStep = function UserDataStep() {
  var _mandatoryFields$gend, _mandatoryFields$firs, _mandatoryFields$last;
  var _useContext = useContext(ApiContext),
    data = _useContext.data,
    config = _useContext.config;
  var _useContext2 = useContext(WizardContext),
    setUserData = _useContext2.setUserData,
    userData = _useContext2.userData,
    dialogId = _useContext2.dialogId,
    currentLine = _useContext2.currentLine,
    leadId = _useContext2.leadId,
    recruiterId = _useContext2.recruiterId,
    stepData = _useContext2.stepData,
    UserDataStepLayoutContainer = _useContext2.components.UserDataStepLayoutContainer;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var optinType = getOptinType(data) || 'hint';
  var mandatoryFields = getMandatoryFieldOptions(data);
  return jsx(FluidMaxContainer, null, jsx(UserDataStepLayoutContainer, null, jsx(WizardHeading, null, getContactDescriptionText(data)), jsx(Formik, {
    initialValues: userData,
    validationSchema: buildValidationSchema({
      gender: (_mandatoryFields$gend = mandatoryFields === null || mandatoryFields === void 0 ? void 0 : mandatoryFields.gender) !== null && _mandatoryFields$gend !== void 0 ? _mandatoryFields$gend : true,
      firstName: (_mandatoryFields$firs = mandatoryFields === null || mandatoryFields === void 0 ? void 0 : mandatoryFields.first_name) !== null && _mandatoryFields$firs !== void 0 ? _mandatoryFields$firs : true,
      lastName: (_mandatoryFields$last = mandatoryFields === null || mandatoryFields === void 0 ? void 0 : mandatoryFields.last_name) !== null && _mandatoryFields$last !== void 0 ? _mandatoryFields$last : true,
      optIn: optinType === 'checkbox' && getOptinContentText(data)
    }),
    onSubmit: function onSubmit(values) {
      formwizardApi().processLead({
        config: config,
        currentLine: currentLine,
        data: data,
        dialogId: dialogId,
        leadId: leadId,
        recruiterId: recruiterId,
        stepData: stepData,
        values: values,
        getAuthenticityToken: getAuthenticityToken,
        getVersion: getVersion,
        setIsLoading: setIsLoading,
        setUserData: setUserData
      }).then(function (_ref2) {
        var redirectUrl = _ref2.redirectUrl;
        // Track last user interaction
        sendTracking('click_formwizard', {
          label: 'last_click',
          category: 'formwizard_interaction'
        });

        // Redirect to the success page,
        // when the lead submission was completed successfully
        //
        // NOTE: Use +window.top.location+ to break out of the
        //       iframe (redirect the whole page/tab).
        window.location.href = redirectUrl;
      });
    }
  }, jsx(Form, null, jsx(Row, {
    mt: 4
  }, jsx(Col, {
    width: {
      base: 1 / 1,
      md: 7 / 12
    }
  }, jsx(Box, {
    mb: 3
  }, jsx(Flex, {
    alignItems: "center"
  }, jsx(Label, {
    mb: 0,
    htmlFor: "gender",
    isRequired: mandatoryFields === null || mandatoryFields === void 0 ? void 0 : mandatoryFields.gender
  }, "Anrede"), jsx(RadioGroup, {
    name: "gender"
  }, jsx(HStack, null, jsx(Field, {
    name: "gender",
    value: "male"
  }, function (_ref3) {
    var field = _ref3.field,
      meta = _ref3.meta;
    return jsx(Fragment, null, jsx(Radio, _extends({
      isInvalid: Boolean(meta.touched && meta.error),
      id: "".concat(field.name, "-male")
    }, field, {
      value: "male"
    }), jsx(Text, {
      as: "span",
      color: "gray.400"
    }, "Herr")));
  }), jsx(Field, {
    name: "gender",
    value: "female"
  }, function (_ref4) {
    var field = _ref4.field,
      meta = _ref4.meta;
    return jsx(Fragment, null, jsx(Radio, _extends({
      isInvalid: Boolean(meta.touched && meta.error),
      id: "".concat(field.name, "-female")
    }, field, {
      value: "female"
    }), jsx(Text, {
      as: "span",
      color: "gray.400"
    }, "Frau")));
  })))), jsx(ErrorMessage, {
    name: "gender",
    component: Feedback
  })), jsx(Row, null, jsx(Col, {
    mb: 3,
    width: {
      base: 1,
      md: 1 / 2
    }
  }, jsx(Field, {
    name: "firstName"
  }, function (_ref5) {
    var field = _ref5.field,
      meta = _ref5.meta;
    return jsx(Fragment, null, jsx(Label, {
      color: "gray.400",
      htmlFor: field.name,
      isRequired: mandatoryFields === null || mandatoryFields === void 0 ? void 0 : mandatoryFields.first_name
    }, "Vorname"), jsx(Input, _extends({
      isInvalid: Boolean(meta.touched && meta.error),
      id: field.name,
      width: "100%",
      bg: "white"
    }, field)), jsx(ErrorMessage, {
      name: field.name,
      component: Feedback
    }));
  })), jsx(Col, {
    mb: 3,
    width: {
      base: 1,
      md: 1 / 2
    }
  }, jsx(Field, {
    name: "lastName"
  }, function (_ref6) {
    var field = _ref6.field,
      meta = _ref6.meta;
    return jsx(Fragment, null, jsx(Label, {
      htmlFor: field.name,
      isRequired: mandatoryFields === null || mandatoryFields === void 0 ? void 0 : mandatoryFields.last_name
    }, "Nachname"), jsx(Input, _extends({
      isInvalid: Boolean(meta.touched && meta.error),
      id: field.name,
      width: "100%",
      bg: "white"
    }, field)), jsx(ErrorMessage, {
      name: field.name,
      component: Feedback
    }));
  }))), jsx(Box, {
    mb: 3
  }, jsx(Field, {
    name: "phone"
  }, function (_ref7) {
    var field = _ref7.field,
      meta = _ref7.meta;
    return jsx(Fragment, null, jsx(Label, {
      htmlFor: field.name,
      isRequired: true
    }, "Telefon"), jsx(Input, _extends({
      isInvalid: Boolean(meta.touched && meta.error),
      type: "tel",
      id: field.name,
      width: "100%",
      bg: "white"
    }, field)), jsx(ErrorMessage, {
      name: field.name,
      component: Feedback
    }));
  })), jsx(Box, {
    mb: 3
  }, jsx(Field, {
    name: "email"
  }, function (_ref8) {
    var field = _ref8.field,
      meta = _ref8.meta;
    return jsx(Fragment, null, jsx(Label, {
      htmlFor: field.name,
      isRequired: true
    }, "E-Mail"), jsx(Input, _extends({
      isInvalid: Boolean(meta.touched && meta.error),
      type: "email",
      id: field.name,
      width: "100%",
      bg: "white"
    }, field)), jsx(ErrorMessage, {
      name: field.name,
      component: Feedback
    }));
  })), jsx(Text, {
    textAlign: "right",
    mb: 2,
    color: "gray.400",
    display: {
      base: 'none',
      md: 'block'
    }
  }, "* Pflichtfelder"), jsx(Box, {
    display: {
      base: 'none',
      md: 'block'
    }
  }, jsx(SubmitButton, {
    isLoading: isLoading
  })), optinType === 'checkbox' && getOptinContentText(data) && jsx(Field, {
    name: "optIn"
  }, function (_ref9) {
    var field = _ref9.field,
      meta = _ref9.meta;
    return jsx(Box, {
      mb: 7
    }, jsx(Flex, null, jsx(Checkbox, _extends({
      isInvalid: Boolean(meta.touched && meta.error),
      id: field.name
    }, field)), jsx(Label, {
      isRequired: true,
      color: "gray.400",
      htmlFor: field.name
    }, htmlToReactParser.parseWithInstructions(getOptinContentText(data), function () {
      return true;
    }, getHtmlToReactParserProcessingInstructions()))), jsx(ErrorMessage, {
      name: field.name,
      component: Feedback
    }));
  })), jsx(Col, {
    width: {
      base: 1 / 1,
      md: 5 / 12
    }
  }, jsx(Flex, {
    height: "100%",
    alignItems: "flex-end"
  }, jsx(Box, null, jsx(Box, {
    display: {
      base: 'none',
      md: 'block'
    }
  }, jsx(TrustBox, null)), jsx(Text, {
    textAlign: "right",
    mb: 2,
    color: "gray.400",
    display: {
      base: 'block',
      md: 'none'
    }
  }, "* Pflichtfelder"), jsx(Box, {
    display: {
      base: 'block',
      md: 'none'
    }
  }, jsx(SubmitButton, {
    isLoading: isLoading
  })), jsx(Box, {
    display: {
      base: 'block',
      md: 'none'
    },
    mt: 2
  }, jsx(TrustBox, null)), jsx(Text, {
    color: "gray.400",
    mb: 0
  }, "Der Service ist kostenfrei."), getAdditionalContentText(data) && jsx(Text, {
    as: "span",
    mb: 0,
    color: "gray.400",
    display: "block"
  }, htmlToReactParser.parseWithInstructions(getAdditionalContentText(data), function () {
    return true;
  }, getHtmlToReactParserProcessingInstructions('additionalContent'))), optinType === 'hint' && getOptinContentText(data) && jsx(Text, {
    as: "span",
    mt: 2,
    mb: 0,
    color: "gray.400",
    display: "block"
  }, htmlToReactParser.parseWithInstructions(getOptinContentText(data), function () {
    return true;
  }, getHtmlToReactParserProcessingInstructions()))))))))));
};
export { UserDataStep as default };